import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '../../custom-material/Services/';
import { ObjectifComponent } from '../objectif/objectif.component';
import { IndicatorComponent } from '../indicator/indicator.component';

import { ObjectifFormComponent } from '../objectif-form/objectif-form.component';
import { ObjectifModel, ChapterModel, IndigroupModel, IndicateurModel, DiagnosticModel, AnswerModel, BuildingModel, UserModel, Colors } from '../../main/Models/';
import { globalData } from 'src/app/main/Models/global.model';


@Component({
  selector: 'rm-audit-generator',
  templateUrl: './t_audit-generator.component.html',
  styleUrls: ['./audit-generator.component.less']
})
export class AuditGeneratorComponent implements OnInit {

  diagnostic: DiagnosticModel = new DiagnosticModel({});
  chapters:Array<ChapterModel> = [];
  currentChapter:number;
  indiGroups = [];
  indicators = [];
  nbIndicators = 0;
  totalBudgets = 0;

  showSummary = false;

  sliceFilter:any = [
    //{'label': '', 'show': true, 'color': '#cccccc', 'count': 0},
  	{'label': 'Alarmant', 'show': true, 'color': Colors.colors[0], 'count': 0},
  	{'label': 'Préocupant', 'show': true, 'color': Colors.colors[1], 'count': 0},
  	{'label': 'Important', 'show': true, 'color': Colors.colors[2], 'count': 0},
  	{'label': 'Positif', 'show': false, 'color': Colors.colors[3], 'count': 0},
  ];


  //precosList:Array<any>;
  objectifsList:Array<any> = [];

  @ViewChild('objSheet') objectifSheet: ObjectifComponent;
  @ViewChild('indicator') indicatorSheet: IndicatorComponent;
  openedObjectif: ObjectifModel = null;
  openedIndicator: IndicateurModel = null;

  constructor(private apiService: ApiService,
              private router: Router,
              private route: ActivatedRoute,
              private dialog: MatDialog,
              private snackBar: MatSnackBar,
              private gd:globalData) { 
                this.gd.toollist = [];
                this.gd.showChooser = false;
                              }

  ngOnInit() {
  	let diagnostic_id = +this.route.snapshot.params['diagnostic'];
    this.loadObjectifs(diagnostic_id).then(()=>{
  	  this.loadCompleteDiagnostic(diagnostic_id);
    });
  }

  loadObjectifs(diagnostic_id)
  {
    return new Promise((resolve, reject)=>{
      let params = this.apiService.createParams({diagnostic: diagnostic_id}, 'eq');
      this.apiService.getFromServer('objectif', params)
        .then(s => s.subscribe((response:any) => {
          response._embedded.objectif.forEach((obj)=>{
            this.objectifsList.push(new ObjectifModel(obj));
            this.totalBudgets += obj.budget;
          });
          resolve(true);
        }));

    });
  }

  /*
  * load diagnostic from the API 
  * (with all data : building, questionnary, chapters, groups, indicators, answers)
  * @param number
  */
  loadCompleteDiagnostic(diagnostic_id)
  {
        //setTimeout is a hack, without it snackBar bugs
    setTimeout(()=>{ this.snackBar.open('Chargement en cours') }, 0);


  	this.apiService.getOneFromServer('diagnostic', diagnostic_id)
	    .then(s => s.subscribe((response:any) => {
	    	this.diagnostic.exchange(response.diagnostic);
	    	this.diagnostic.building.exchange(response.building);
	    	this.diagnostic.questionnary.exchange(response.questionnary);
        	/*****this.sg['currentQuestionnary'] = this.diagnostic.questionnary;*/

	    	response.chapters.forEach((ch)=>{
	    		this.chapters[ch.ordre] = new ChapterModel(ch);
	    	});
        	this.calcInit();

        //stop showing wait signals
        setTimeout(()=>{ this.snackBar.dismiss(); }, 0);

        this.currentChapter = 0;  //-> allow view of indicators
        this.gd.headerTitle = this.diagnostic.questionnary.name.replace('Questionnaire','Audit');
        this.gd.headerIcon = 'account_tree';
        this.gd.headerBuilding = this.gd.findBuildingById(response.building);
        this.diagnostic.building = this.gd.headerBuilding;

        if(this.gd.back != undefined) {
          console.log('gd.back', this.gd.back);
          this.openedIndicator = this.gd.back.indicator;
          this.gd.back = null;
        }
	    }));
  }

  /*
  * First calculation after load :
  * slice for each answers + nb of indicators
  */
  calcInit()
  {
    this.sliceFilter.forEach((s)=>{ s.count = 0; });


    this.showSummary = false;
    this.nbIndicators = 0;
    this.chapters.forEach((chapter:ChapterModel)=>{
      chapter.indiGroups.forEach((indiGroup:IndigroupModel)=>{
        //this.nbIndicators += indiGroup.indicators.length;

        indiGroup.indicators.forEach((indicator:IndicateurModel)=>{
          let score = indicator.answer.finalScore;
          let slice = this.diagnostic.questionnary.getSlice(score);
          indicator.answer.slice = slice;

          let filteredSlice = this.sliceFilter.find((sl)=>{
              return sl.label==slice.name;
          });
          if(filteredSlice) {
            filteredSlice.count++;
            this.nbIndicators++;
          }

          /*indicator.preco = this.precosList.find((p)=>{ 
            return p.indicator_id==indicator.id;
          });
          */
          if(this.objectifsList && this.objectifsList.length) {
            let obj:ObjectifModel = this.objectifsList.find((o:ObjectifModel)=>{
              return o.answer.id==indicator.answer.id;
            });
            if(obj!=undefined) indicator.answer.objectif = obj;
          }
          
        })
      })
    });
    this.showSummary = true;
  }

  getIndicatorList(ig:IndigroupModel)
  {
    return ig.indicators.filter((i:IndicateurModel)=>{
      if(i.answer.slice.name=='') return false;
      let slice = this.sliceFilter.find((sl)=>{
          return sl.label==i.answer.slice.name;
      });
      return slice.show;
    });
  }

  openIndicator(indicator:IndicateurModel)
  {
    this.openedIndicator=indicator;
    //this.indicatorSheet.showPreco(indicator);
  }

  displayObjectif(objectif:ObjectifModel)
  {
    this.openedObjectif = objectif;
  }

  goBack()
  {
      this.router.navigate(['/buildings/'+this.diagnostic.building.id]);
  }

}
